import { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

const Layout = ({ children }) => {
  const [isZoomed, setIsZoomed] = useState(false)

  const handleToggleZoom = () => {
    setIsZoomed(!isZoomed)
  }

  return (
    <div className={`layout ${isZoomed ? 'zoomed' : ''}`} style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header isZoomed={isZoomed} onToggleZoom={handleToggleZoom} />
      <main className="main" style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
